import type { RefObject } from "react";

import type { Popover as BasePopover } from "@base-ui/react/popover";

type AlignOffset = NonNullable<BasePopover.Positioner.Props["alignOffset"]>;

export function pointerOffsetIn(element: Element, clientX: number): number {
  const rect = element.getBoundingClientRect();

  return clientX - (rect.left + rect.right) / 2;
}

export function pointerAlignOffset(
  pointerOffsetRef: RefObject<number>,
  arrow: boolean,
): AlignOffset {
  if (arrow) {
    return () => pointerOffsetRef.current;
  }

  return ({ anchor, positioner }) => {
    const maxOffset = Math.max(0, (anchor.width - positioner.width) / 2);

    return Math.min(Math.max(pointerOffsetRef.current, -maxOffset), maxOffset);
  };
}
